import request from '@/utils/httpRequest'

export default class applybillService {
    queryById(id) {
        return request({
            url: '/mater/applybill/' + id,
            // url: 'http://172.16.1.68:18680/mater/applybill/' + id,
            method: 'get',
			class:'mater'
        })
    }
}
